export const LOAD_ORDERS = 'LOAD_ORDERS'
export const SET_ORDERS = 'SET_ORDERS'
export const SET_ORDER = 'SET_ORDER'
export const UPDATE_ORDER = 'UPDATE_ORDER'
export const CHANGE_ORDER = 'CHANGE_ORDER'
export const VALIDATE_ORDER = 'VALIDATE_ORDER'